import React, { useState, useEffect, useCallback, useRef } from 'react';
import moment from 'moment';
import Contents from '../../../contents/index';
import axios from 'axios';
import ModalContentBase from '../../components/modal/modal_content_base';
import Loader from '../../../../components/loader.jsx';
import BlogTagsInput from './tags_input';
import DepartmentCheckboxList from './department_checkbox_list';
import compressImage from '../../../../lib/image_compressor.js';

const Edit = ({
  blog,
  myCircle,
  blogTags,
  pastTags,
  departments,
  isApp,
  events,
  imageUrlMedium,
  pdfUrl,
  userAgent,
  companyId,
  blogName,
  blogCategory,
  blogCategories,
  isCommunityAdmin,
}) => {
  const [title, setTitle] = useState(blog.title);
  const [image, setImage] = useState(imageUrlMedium);
  const [publishDatetime, setPublishDatetime] = useState(
    moment(blog.publish_datetime).format('YYYY-MM-DDTHH:mm:ss')
  );
  const [publicType, setPublicType] = useState(blog.public_type);
  const [isMemberOnly, setIsMemberOnly] = useState(blog.is_member_only);
  const [isForAllMembers, setIsForAllMembers] = useState(
    blog.is_for_all_members
  );
  const [canShowDepartments, setCanShowDepartments] = useState(
    blog.can_show_departments || ''
  );
  const [isDraft, setIsDraft] = useState(blog.is_draft);
  const [isDeleted, setIsDeleted] = useState(false);
  const [tags, setTags] = useState(blogTags || []);
  const [eventId, setEventId] = useState(blog.event_id);
  const [selectedCategory, setSelectedCategory] = useState(blogCategory);
  const [uploading, setUploading] = useState(false);
  const [isFixed, setIsFixed] = useState(blog.is_fixed);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  useEffect(() => {
    const departmentsArray = blog.can_show_departments
      ? blog.can_show_departments.split(',').map((dep) => dep.trim())
      : [];
    setSelectedDepartments(departmentsArray);
  }, [blog.can_show_departments]);

  const [pdfUploading, setPdfUploading] = useState(false);
  const [pdf, setPdf] = useState(pdfUrl);

  const inputRef = useRef(null);

  const updateImage = useCallback(
    async (photoFile) => {
      const compressedFile = await compressImage(photoFile);
      setUploading(true);
      let formData = new FormData();
      formData.append('file', compressedFile);
      axios
        .patch(`/api/my_circle/blog/${blog.id}/update_image`, formData)
        .then((response) => {
          setImage(response.data.image_url_medium);
        })
        .catch(() => {})
        .finally(() => {
          setUploading(false);
        });
    },
    [blog]
  );

  const updateBlogToServer = (status, boolean) => {
    $.ajax({
      url: '/api/my_circle/blog/update',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        id: blog.id,
        event_id: eventId,
        title: title,
        content: '',
        publish_datetime: publishDatetime,
        public_type: publicType,
        is_draft: status === 'draft' ? boolean : isDraft,
        is_deleted: status === 'delete' ? boolean : isDeleted,
        is_members_only: isMemberOnly,
        is_for_all_members: isForAllMembers,
        can_show_departments: canShowDepartments.trim(), // 前後の空白を削除して保存
        tags: tags.join(' '),
        is_fixed: isFixed,
        blog_category: selectedCategory,
      },
    })
      .done(() => {
        if (companyId && !myCircle) {
          if (isCommunityAdmin) {
            window.location.href = `/community/${companyId}/blogs`;
          } else {
            window.location.href = `/community/${companyId}`;
          }
        } else {
          window.location.href = `/my_circle/${myCircle.id}/blogs/`;
        }
      })
      .fail(() => {});
  };

  const handleTitleInput = (e) => {
    setTitle(e.target.value);
  };

  const handleTagClick = (tag) => {
    if (!tags.includes(tag)) {
      const updatedTags = [...tags, tag];
      setTags(updatedTags);
    }
  };

  const handleTagsInput = (updatedTags) => {
    setTags(updatedTags);
  };

  const handleDraftButton = () => {
    var result = window.confirm('下書きで保存しますか？');
    if (result) {
      updateBlogToServer('draft', true);
    }
  };

  const handleDeleteButton = () => {
    var result = window.confirm('このブログを削除しますか？');
    if (result) {
      updateBlogToServer('delete', true);
    }
  };

  const handleSubmitButton = () => {
    var result = window.confirm('作成しますか?');
    if (result) {
      updateBlogToServer('draft', false);
    }
  };

  const handlePostDateChange = (e) => {
    setPublishDatetime(e.target.value);
  };

  const handleKeydown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      e.target.blur();
    }
  };

  const handleToggleChange = useCallback(() => {
    const updatedIsFixed = !isFixed; // トグルの状態を反転
    setIsFixed(updatedIsFixed);
  }, [isFixed, blog.id]);

  const handleDepartmentChange = useCallback((updatedDepartments) => {
    const cleanedDepartments = updatedDepartments.filter(
      (dep) => dep.trim() !== ''
    );
    setSelectedDepartments(cleanedDepartments);
    setCanShowDepartments(cleanedDepartments.join(','));
  }, []);

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const updatePdf = useCallback(
    (e) => {
      setPdfUploading(true);

      if (e.target.files.length === 0) {
        setPdfUploading(false);
        return;
      }
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      axios
        .patch(`/api/my_circle/blog/${blog.id}/update_pdf`, formData)
        .then((response) => {
          setPdf(response.data.pdf_url);
        })
        .catch(() => {})
        .finally(() => {
          setPdfUploading(false);
          // ファイル入力をリセット
          e.target.value = null;
        });
    },
    [blog]
  );

  const deletePdf = useCallback(() => {
    if (!pdf) return;
    if (confirm('PDFを削除しますか？')) {
      axios
        .post(`/api/my_circle/blog/${blog.id}/delete_pdf`)
        .then(() => {
          setPdf(null);
        })
        .catch(() => {});
    }
  }, [pdf, blog]);

  return (
    <div className="">
      <div
        className="bg-white py-3"
        style={{
          position: 'sticky',
          top: userAgent == 'pc' ? '6%' : isApp ? '0%' : '8%',
          zIndex: '20',
        }}
      >
        <div className="container col-md-8">
          <div className="row align-items-center">
            <div className="col-3" />
            <div className="col-9 d-flex justify-content-end">
              <div className="">
                <ModalContentBase
                  previewContent={previewContent}
                  modalContent={
                    <DetailContent
                      publicType={publicType}
                      isMemberOnly={isMemberOnly}
                      isForAllMembers={isForAllMembers}
                      canShowDepartments={canShowDepartments}
                      eventId={eventId}
                      publishDatetime={publishDatetime}
                      tags={tags}
                      setPublicType={setPublicType}
                      setIsMemberOnly={setIsMemberOnly}
                      selectedDepartments={selectedDepartments}
                      setIsForAllMembers={setIsForAllMembers}
                      setCanShowDepartments={setCanShowDepartments}
                      setEventId={setEventId}
                      handlePostDateChange={handlePostDateChange}
                      isFixed={isFixed}
                      handleToggleChange={handleToggleChange}
                      handleDepartmentChange={handleDepartmentChange}
                      departments={departments}
                      handleTagClick={handleTagClick}
                      handleTagsInput={handleTagsInput}
                      events={events}
                      handleDeleteButton={handleDeleteButton}
                      companyId={companyId}
                      myCircle={myCircle}
                      blogName={blogName}
                      pastTags={pastTags}
                      blogCategories={blogCategories}
                      selectedCategory={selectedCategory}
                      setSelectedCategory={setSelectedCategory}
                      handleCategoryChange={handleCategoryChange}
                      isCommunityAdmin={isCommunityAdmin}
                    />
                  }
                />
              </div>
              <button
                type="button"
                className="text-fz-13px text-fw-500 p-0 m-0 mr-2 a-button__top a-button__top--outline"
                style={{ height: '35px', width: '100px' }}
                onClick={handleDraftButton}
              >
                下書き
              </button>
              {(!companyId || isCommunityAdmin) && (
                <button
                  type="button"
                  onClick={handleSubmitButton}
                  className="text-fz-13px text-fw-500 btn a-button__top a-button--orange text-white m-0"
                  style={{ height: '35px', width: '100px' }}
                >
                  作成
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="pt-5" />
      <div className="container col-lg-8">
        <figure style={{ position: 'relative' }}>
          <label htmlFor="image_data" className="w-100">
            {uploading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: '400px', width: '100%' }}
              >
                <Loader isActive={true} />
              </div>
            ) : image ? (
              <img
                src={image}
                alt=""
                style={{
                  height: '400px',
                  // width: '100%',
                  objectFit: 'contain',
                  cursor: 'pointer',
                }}
              />
            ) : (
              <span className="d-block text-black-20 text-fz-small">
                <img
                  src="/assets2019/image.svg"
                  alt=""
                  className="cursor-pointer logo-img-circle bg-graydark"
                  style={{ width: '70px', height: '70px' }}
                />
              </span>
            )}
            <input
              type="file"
              accept="image/png, image/jpeg, image/heic, image/heif, .heic, .heif"
              onChange={(e) => {
                updateImage(e.target.files[0]);
              }}
              id="image_data"
              style={{ display: 'none' }}
            />
          </label>
        </figure>
      </div>
      <div className="container col-lg-8">
        <textarea
          type="text"
          className="textarea-no-border bg-white"
          placeholder={
            companyId && !myCircle ? `${blogName}タイトル` : 'ブログタイトル'
          }
          value={title}
          onKeyDown={(e) => handleKeydown(e)}
          onChange={handleTitleInput}
        />
        {pdf ? (
          <div className="text-fz-20px text-fw-bold">
            <span
              style={{ color: '#48A3E9', cursor: 'pointer' }}
              onClick={() => {
                inputRef.current && inputRef.current.click();
              }}
            >
              PDFを変更
            </span>
            <span
              className="text-danger ml-4"
              style={{ cursor: 'pointer' }}
              onClick={deletePdf}
            >
              PDFを削除
            </span>
          </div>
        ) : (
          <p
            className="text-fz-20px text-fw-bold d-inline-block m-0"
            style={{ color: '#48A3E9', cursor: 'pointer' }}
            onClick={() => {
              inputRef.current && inputRef.current.click();
            }}
          >
            PDFで記事をアップロード
          </p>
        )}
        <p className="mt-3">
          PDFで記事を作成した場合、編集モードは使えなくなります
        </p>
        <input
          type="file"
          ref={inputRef}
          accept="application/pdf"
          onChange={updatePdf}
          className="d-none"
        />
      </div>
      {pdfUploading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '400px', width: '100%' }}
        >
          <Loader isActive={true} />
        </div>
      ) : pdf ? (
        <div className="container col-lg-8">
          <iframe src={pdf} width="100%" height="800px" />
        </div>
      ) : (
        <Contents
          foreignKeyId={blog.id}
          isApp={isApp}
          userAgent={userAgent}
          model={'Blog'}
        />
      )}
    </div>
  );
};

export default Edit;

const previewContent = (
  <button
    type="button"
    className="text-fz-13px text-fw-500 p-0 m-0 mr-2 a-button__top a-button__top--outline"
    // className="text-fz-13px text-fw-500 btn a-button__top a-button--orange text-white m-0"
    style={{ height: '35px', width: '100px' }}
  >
    詳細設定
  </button>
);

const DetailContent = ({
  publicType,
  isMemberOnly,
  isForAllMembers,
  eventId,
  publishDatetime,
  tags,
  setPublicType,
  setIsMemberOnly,
  setIsForAllMembers,
  setEventId,
  handlePostDateChange,
  handleTagClick,
  handleTagsInput,
  isFixed,
  handleToggleChange,
  selectedDepartments,
  handleDepartmentChange,
  events,
  handleDeleteButton,
  companyId,
  myCircle,
  pastTags,
  departments,
  blogCategories,
  selectedCategory,
  handleCategoryChange,
}) => {
  return (
    <div className="container pb-4">
      {myCircle && (
        <div className="">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            公開範囲
          </p>
          <select
            className="form-control form-control-lg"
            value={publicType}
            onChange={(e) => setPublicType(e.target.value)}
          >
            <option value="1">全体公開</option>
            <option value="2">サークル内限定</option>
          </select>
        </div>
      )}
      {publicType && parseInt(publicType) === 1 && companyId && (
        <div>
          <div className="">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              コミュニティメンバー以外にも公開する
            </p>
          </div>
          <div className="">
            <select
              className="form-control form-control-lg"
              value={isMemberOnly ? 'true' : 'false'}
              onChange={(e) => setIsMemberOnly(e.target.value === 'true')}
            >
              <option value="false">する</option>
              <option value="true">しない</option>
            </select>
          </div>
          <div>
            <div className="">
              <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
                特定の部署に公開を制限する
              </p>
            </div>
            <div className="">
              <select
                className="form-control form-control-lg"
                value={isForAllMembers ? 'true' : 'false'}
                onChange={(e) => setIsForAllMembers(e.target.value === 'true')}
              >
                <option value="false">する</option>
                <option value="true">しない</option>
              </select>
            </div>
            {!isForAllMembers && (
              <div>
                <p className="text-fz-14px text-fw-bold text-black-50 mb-2">
                  公開する部署
                </p>
                <DepartmentCheckboxList
                  departments={departments}
                  selectedDepartments={selectedDepartments}
                  onDepartmentChange={handleDepartmentChange}
                />
              </div>
            )}
          </div>
        </div>
      )}
      {companyId && myCircle && (
        <div>
          <div className="">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              イベント活動報告にする
            </p>
          </div>
          <div className="">
            <select
              className="form-control form-control-lg"
              value={eventId}
              onChange={(e) => setEventId(e.target.value)}
            >
              <option value="">しない</option>
              {events &&
                events.map((event) => (
                  <option key={event.id} value={event.id}>
                    {moment(event.event_date).format('MM/DD')} {event.title}
                  </option>
                ))}
            </select>
          </div>
        </div>
      )}
      <div className="">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          予約投稿
        </p>
      </div>
      <div className="">
        <input
          type="datetime-local"
          className="p-1 w-100 form-control form-control-lg"
          value={publishDatetime}
          onChange={handlePostDateChange}
        />
      </div>
      {companyId && !myCircle && (
        <div>
          <div className="">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              カテゴリを選択する
            </p>
          </div>
          <div className="">
            <select
              className="form-control form-control-lg"
              value={selectedCategory}
              onChange={handleCategoryChange}
            >
              <option value="">カテゴリを選択</option>
              {blogCategories &&
                blogCategories.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))}
            </select>
          </div>
        </div>
      )}
      <div className="">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-0 mt-3 d-inline-block">
          カテゴリ
        </p>
      </div>
      <div className="mt-0">
        <BlogTagsInput blogTags={tags} handleTagsInput={handleTagsInput} />
      </div>
      <div>
        <p className="text-gray text-fz-small mt-1 mb-0">
          改行またはEnter Keyで登録を保存できます。
        </p>
      </div>
      {/* ここに過去使ったタグを表示する */}
      <div className="past-tags mt-2 mb-0">
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            {pastTags &&
              pastTags.map((tag, index) => (
                <li
                  key={index}
                  onClick={() => handleTagClick(tag)} // タグをクリックした際にタグを追加
                  className="btn btn-outline-primary btn-outline-blue btn-sm btn-sm--expand mr-2 d-inline-block"
                  style={{
                    cursor: 'pointer',
                    userSelect: 'none',
                  }}
                >
                  {tag}
                </li>
              ))}
          </ul>
        </div>
      {companyId && (
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div className="d-flex align-items-center">
            <div className="col-auto pl-2 pr-2">
              <img
                src="/assets2019/img/community/product/icon-fixed.svg"
                style={{ width: '30px', height: '40px' }}
              />
            </div>
            <div className="text-left">
              <p className="text-fz-14px text-fw-bold text-black-50 mb-0">
                TOPに固定する
              </p>
            </div>
          </div>

          <div className="toggle_switch d-flex">
            <input
              type="checkbox"
              id="is_fixed_toggle"
              checked={isFixed}
              onChange={handleToggleChange}
            />
            <label htmlFor="is_fixed_toggle" className="toggle_label"></label>
          </div>
        </div>
      )}
      <div className="">
        <button
          type="button"
          className="text-fz-14px text-fw-bold text-danger mb-2 mt-3 p-0 d-inline-block border-0 bg-white"
          onClick={handleDeleteButton}
        >
          このブログを削除する
        </button>
      </div>
    </div>
  );
};
